import styled, { keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`

export const PublicBookingPageWrap = styled.div`
  width: 100%;
  min-height: calc(100vh - 64px);
  background: linear-gradient(165deg, #faf9fc 0%, #f3f0f9 35%, #fdfcff 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 24px 16px 48px;
  @media (min-width: 768px) {
    padding: 40px 24px 64px;
  }
`

export const PublicBookingContent = styled.div`
  width: 100%;
  max-width: 900px;
  animation: ${fadeIn} 0.4s ease-out;
`

export const PublicBookingHero = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 24px;
  margin-bottom: 20px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
  @media (min-width: 660px) {
    padding: 32px 28px;
    gap: 24px;
  }
`

export const PublicBookingAvatar = styled.img`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(113, 84, 176, 0.2);
  box-shadow: 0 4px 16px rgba(113, 84, 176, 0.15);
  flex-shrink: 0;
  @media (min-width: 660px) {
    width: 88px;
    height: 88px;
  }
`

export const PublicBookingHeroInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const PublicBookingMentorName = styled.h1`
  margin: 0 0 6px 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1f1b24;
  letter-spacing: -0.02em;
  line-height: 1.3;
  @media (min-width: 660px) {
    font-size: 1.6rem;
  }
`

export const PublicBookingMentorBio = styled.p`
  margin: 0;
  font-size: 0.9rem;
  font-weight: 400;
  color: #5c5563;
  line-height: 1.5;
  @media (min-width: 660px) {
    font-size: 0.95rem;
  }
`

export const PublicBookingSessionCard = styled.div`
  padding: 24px;
  margin-bottom: 24px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
  @media (min-width: 768px) {
    padding: 28px 32px;
  }
`

export const PublicBookingSessionLabel = styled.span`
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8b8398;
  margin-bottom: 6px;
`

export const PublicBookingSessionTitle = styled.h2`
  margin: 0 0 8px 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1f1b24;
  letter-spacing: -0.02em;
  line-height: 1.35;
  @media (min-width: 768px) {
    font-size: 1.35rem;
  }
`

export const PublicBookingSessionMeta = styled.div`
  margin: 0 0 12px 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #5c5563;
  line-height: 1.45;
`

export const PublicBookingSessionDesc = styled.p`
  margin: 0 0 16px 0;
  font-size: 0.9rem;
  font-weight: 400;
  color: #5c5563;
  line-height: 1.5;
`

export const PublicBookingPriceWrap = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
`

export const PublicBookingPriceStrike = styled.span`
  text-decoration: line-through;
  font-weight: 400;
  color: #8b8398;
  font-size: 0.95rem;
`

export const PublicBookingPriceFinal = styled.span`
  font-weight: 700;
  color: #1f1b24;
  font-size: 1.1rem;
`

export const PublicBookingCalendarCard = styled.div`
  padding: 24px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.04);
  @media (min-width: 768px) {
    padding: 28px 32px;
  }
`

export const PublicBookingCalendarHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`

export const PublicBookingCalendarTitle = styled.h3`
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #1f1b24;
  letter-spacing: -0.02em;
  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`

export const PublicBookingSignInPrompt = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`

export const PublicBookingSignInText = styled.span`
  font-size: 0.9rem;
  font-weight: 400;
  color: #5c5563;
`

export const PublicBookingSignInLink = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: #7154b0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

export const PublicBookingCalendarRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
    gap: 28px;
  }
`

export const PublicBookingCalendarWrap = styled.div`
  width: 100%;
  max-width: 360px;
  flex-shrink: 0;

  .react-calendar {
    font-family: 'Outfit', Arial, sans-serif;
    background: #faf9fc;
    color: #1f1b24;
    width: 100%;
    border: none;
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    box-sizing: border-box;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    display: flex;
    height: 40px;
    margin-bottom: 12px;
  }
  .react-calendar__navigation button {
    color: #3d3744;
    min-width: 40px;
    background: none;
    font-size: 15px;
    font-weight: 600;
  }
  .react-calendar__navigation button:enabled:hover {
    background: rgba(113, 84, 176, 0.08);
    border-radius: 10px;
    color: #7154b0;
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-size: 0.7rem;
    font-weight: 600;
    color: #8b8398;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 8px 0;
  }
  .react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none;
  }
  .react-calendar__tile {
    max-width: 100%;
    padding: 10px 8px;
    background: none;
    text-align: center;
    font-weight: 500;
    font-size: 0.9rem;
    line-height: 1.2;
    border-radius: 10px;
  }
  .react-calendar__tile:disabled {
    color: #c4bdd1;
  }
  .react-calendar__tile:enabled:hover {
    background: rgba(113, 84, 176, 0.1);
    color: #7154b0;
  }
  .react-calendar__tile--active {
    background: rgba(113, 84, 176, 0.18);
    color: #5c3d8a;
    font-weight: 700;
  }
  .react-calendar__tile--active:enabled:hover {
    background: rgba(113, 84, 176, 0.25);
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    color: #c4bdd1;
  }
`

export const PublicBookingTimeZoneSelect = styled.select`
  width: 100%;
  max-width: 280px;
  margin-top: 16px;
  padding: 10px 14px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #3d3744;
  background: #fff;
  border: 1.5px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  cursor: pointer;
  font-family: inherit;
  &:focus {
    outline: none;
    border-color: rgba(113, 84, 176, 0.4);
    box-shadow: 0 0 0 3px rgba(113, 84, 176, 0.1);
  }
`

export const PublicBookingTimeSlotsWrap = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;
  @media (min-width: 768px) {
    min-width: 220px;
    max-width: 280px;
  }
`

export const PublicBookingTimeSlotsHeading = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: #3d3744;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`

export const PublicBookingTimeSlotsScroll = styled.div`
  height: 240px;
  overflow-y: auto;
  padding-right: 4px;
  animation: ${fadeIn} 0.25s ease-out;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(113, 84, 176, 0.25);
    border-radius: 4px;
  }
`

export const PublicBookingTimeSlotRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
`

export const PublicBookingTimeSlotBtn = styled.button`
  flex: 1;
  min-width: 0;
  padding: 10px 14px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #5c3d8a;
  background: rgba(113, 84, 176, 0.08);
  border: 1.5px solid rgba(113, 84, 176, 0.25);
  border-radius: 12px;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  &:hover {
    background: rgba(113, 84, 176, 0.14);
    border-color: rgba(113, 84, 176, 0.4);
  }
`

export const PublicBookingTimeSlotConfirm = styled.button`
  padding: 10px 18px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  background: linear-gradient(135deg, #7154b0 0%, #5c3d8a 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 2px 10px rgba(113, 84, 176, 0.35);
  transition: transform 0.1s ease, box-shadow 0.2s ease;
  flex-shrink: 0;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(113, 84, 176, 0.4);
  }
  &:active {
    transform: translateY(0);
  }
`

export const PublicBookingNoSlots = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #8b8398;
  padding: 12px 0;
`

export const PublicBookingFaqLink = styled.button`
  margin-top: 24px;
  padding: 0;
  font-size: 0.9rem;
  font-weight: 500;
  color: #7154b0;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  &:hover {
    text-decoration: underline;
  }
`
